<template>
  <div class="sds-search">
    <div>
      <div class="products" v-if="results.rows.length > 0">
        <div v-for="product in filteredRows" class="product-entry" @click="onProductClicked(product)">
          <div
            class="product-image"
            :style="{backgroundImage: 'url(' + product.imageUrl +')'}"
          ></div>
          <div class="product-details">
            <div>
              <div class="product-title" style="word-wrap: break-word;">{{product.title}}</div>
              <div class="product-subtitle" style="word-wrap: break-word;">{{product.subtitle || labels.defaultSubtitle}}</div>
              <div class="product-description" style="word-wrap: break-word;">
                <span v-html="cropText(product.description)"></span>&nbsp;
                <div class="blue-arrow animated" style="display: inline;" v-if="false" @click="onProductMoreClicked(product.url)">{{labels.more}}</div>
              </div>
            </div>
          </div>
        </div>
        <Pager
          :total-items="results.totalRows"
          :current-items="filteredRows.length"
          @click="onShowMore"
        ></Pager>
      </div>
      <div class="no-items" v-if="results.rows.length == 0 && !isLoading && filterIsValid">{{labels.noItemsFound}}</div>
      <div class="no-items" v-if="!filterIsValid">{{labels.filterNotValid}}</div>
      <div class="please-wait" v-if="isLoading">
        <img src="../assets/pic_loading.gif" />
      </div>
    </div>
    <SDSPopup :product="currentProduct" v-if="currentProduct" @close="currentProduct = null"></SDSPopup>
  </div>
</template>

<script>
import { Bus } from "./services/bus.js";
import { Labels } from "./services/labels.js";
import { Settings } from "./services/settings.js";
import { Utils } from "./services/utils.js";
import Pager from "./ui/Pager.vue";
import SDSPopup from "./SDSPopup.vue";
import axios from "axios";
import { SessionState } from "./services/session-state.js";

export default {
  name: "SDSSearch",
  components: {
    Pager,
    SDSPopup
  },
  props: {
    resultCount: String
  },
  data() {
    return {
      labels: Labels,
      settings: Settings,
      isLoading: false,
      filterIsValid: true,
      currentQuery: "",
      currentProduct: null,
      tags: "",
      results: {
        rows: [],
        totalRows: 0
      },
      filteredRows: [],
      isFirstQuery: true
    };
  },
  created() {
    Bus.$on("start-search", this.search);
  },
  beforeDestroy() {
    Bus.$off("start-search");
  },
  mounted() {
    
  },
  methods: {
    search(filters) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      console.log("Searching for sdses with " + filters.query);
      this.results = {rows: [], totalRows: 0};
      this.filteredRows = [];
      if (filters.query.length < 4 || filters.query.toLowerCase() === "sds") {
        this.filterIsValid = false;
        //oThis.$emit("update:modelValue", oThis.results.totalRows);
        oThis.$emit("update:modelValue", "> 100");
        return;
      } else {
        this.filterIsValid = true;
      }
      if (filters.query && !Settings.allowBulkNumberSearch && !isNaN(filters.query.trim()) && filters.query.trim().length === 6) {
        //we don't allow searching by bulk number
        console.log("Searching SDS files by bulk number is not allowed!");
        oThis.results = { rows: [], totalRows: 0 };
        oThis.$emit("update:modelValue", 0);
        return;
      }
      oThis.isLoading = true;
      this.isFirstQuery = false;
      var url = Utils.constructNewSDSQueryUrl(
        filters.query
      );
      console.log(url);
      axios
        .get(url)
        .then(function(response) {
          oThis.results = Utils.processSDSSearchResults(response);
          if (oThis.results.totalRows > Settings.itemsPerPage) {
            oThis.filteredRows = oThis.results.rows.slice(0, Settings.itemsPerPage);
          } else {
            oThis.filteredRows = oThis.results.rows;
          }
          oThis.$emit("update:modelValue", oThis.results.totalRows);
          Utils.applyVisualUpdates(".sds-search");
          oThis.isLoading = false;
          
          Utils.reportResultsToAnalytics(
            "SDS Search",
            filters.query,
            oThis.results.totalRows
          );
        })
        .catch(function(err) {
          console.error("Error loading SDSes: " + err.message);
          oThis.results = { rows: [], totalRows: 0 };
          oThis.$emit("update:modelValue", oThis.results.totalRows);
          oThis.isLoading = false;
        });
    },
    onShowMore() {
      console.log("Displaying more SDSes with " + this.currentQuery);
      if (this.filteredRows.length < this.results.totalRows) {
        let count = Math.min(this.filteredRows.length + Settings.itemsPerPage, this.results.totalRows);
        this.filteredRows.push(...this.results.rows.splice(this.filteredRows.length, this.filteredRows.length + count));
      }
    },
    onProductClicked(product) {
      if (!product) return;
      console.log(`Product ${product.title} clicked.`);
      this.currentProduct = product;
    },
    onProductMoreClicked(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    cropText(text) {
      if (!text) return "";
      if (text.length > 200) {
        text = text.substring(0, 200);
        let spacePos = text.lastIndexOf(" ");
        let dotPos = text.lastIndexOf(".");
        let actualPos = Math.max(spacePos, dotPos);
        if (actualPos > 0) {
          text = text.substring(0, actualPos);
        }
        text += "...";
      }
      return text;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width: 100%;
  justify-content: center;
}

.sds-search .products {
  width: 100%;
}

.products .product-entry {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px dotted #dddddd;
  padding-bottom: 10px;
  cursor: pointer;
}

.products .product-entry div.product-image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  min-width: 64px;
}

.products .product-entry div.product-details {
  margin-left: 10px;
  color: #323232;
}

.products .product-entry div.product-details div.product-title {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 700;
}

.products .product-entry div.product-details .product-subtitle {
  font-family: "Gotham SSm A";
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
}

.products .product-entry a.product-details .product-description {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 15px;
}

/*.products .product-entry div.morelink {
  display: inline-block;
  padding-top: 1px;
  padding-left: 10px;
  font-family: "Gotham SSm A", "Gotham SSm B", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: inherit;
  text-transform: uppercase;
  background-image: url("../assets/bullet-arrow-blue.png");
  background-repeat: no-repeat;
  background-size: 6px 9px;
  background-position: 0px 4px;
  color: #2655FF;
}*/

.morelink {
  cursor: pointer;
}

@media all and (max-width: 780px) {
  .sds-search > div {
    flex-wrap: wrap-reverse;
  }

  .sds-search .products {
    width: 100%;
  }
}
</style>
